import React from "react";

import { SwiperCarousel } from "supercell-frontend-base/src/components/swiper-carousel";
import { CarouselSlide } from "supercell-frontend-base/src/components/swiper-carousel/slide";
import { Grid } from "supercell-frontend-base/src/components/grid";
import { List } from "supercell-frontend-base/src/components/list";
import { ListArticle } from "supercell-frontend-base/src/components/list/article";
import { ContentfulSocialLinks } from "supercell-frontend-base/src/components/contentful-social-links";
import { Tab } from "supercell-frontend-base/src/components/inbox/tab";

import { filterNewsFeed } from "supercell-frontend-base/src/utils/filter-news-feed";
import { filterEntry } from "supercell-frontend-base/src/targeting/targeting";
import { RogueGameParams } from "../../validation/game-params";
import { useGameParamsContext } from "supercell-frontend-base/src/stores/gameParams";

import styles from "./styles.modules.scss";

export const NewsView = () => (
    <Tab namespace="news">
        {({ locale, data }) => {
            const { gameParams } = useGameParamsContext<RogueGameParams>();

            const filterArticles = (a: InboxArticle) =>
                filterNewsFeed(a) && filterEntry(a, gameParams);

            return (
                <div className={`news ${styles.news}`}>
                    <Grid>
                        {data.events && data.events["length"] > 0 ? (
                            <div className={`events ${styles.events}`}>
                                <SwiperCarousel
                                    locale={locale}
                                    Slide={CarouselSlide}
                                    slides={data.events.filter((e) =>
                                        filterEntry(e, gameParams),
                                    )}
                                />
                            </div>
                        ) : null}

                        {data.articles ? (
                            <div className={`articles ${styles.articles}`}>
                                <List
                                    Item={ListArticle}
                                    items={data.articles.filter((e) =>
                                        filterArticles(e, gameParams),
                                    )}
                                    footer={
                                        <ContentfulSocialLinks
                                            links={data.socialLinks}
                                        />
                                    }
                                />
                            </div>
                        ) : null}
                    </Grid>
                </div>
            );
        }}
    </Tab>
);
